import React, { ReactElement } from "react";
import Checkbox from "../checkbox";
import { NOOP } from "../utils/common-util";
import { CheckboxFilterInputProps } from "./filter.types";
import MultiFilterWrapper from "./multi-filter-wrapper";

const CheckboxFilterInput = ({
  showAllMode,
  selectedValues = [],
  onChange = NOOP,
  showMoreText = "Show more filters",
  showFewerText = "Show fewer filters",
  options,
  showFewOptionsCount,
}: CheckboxFilterInputProps): ReactElement => {
  const onChangeHandle = (
    e: React.ChangeEvent<HTMLInputElement>,
    clickedItemValue: string
  ): void => {
    let newActiveItems = [];
    if (e.currentTarget.checked) {
      newActiveItems = [
        ...Array.from(new Set([...selectedValues, clickedItemValue])),
      ];
    } else {
      newActiveItems = selectedValues?.filter(
        (item) => item !== clickedItemValue
      );
    }
    onChange(e, newActiveItems);
  };

  return options ? (
    <MultiFilterWrapper
      showAllMode={showAllMode}
      showMoreText={showMoreText}
      showFewerText={showFewerText}
      optionsCount={options.length}
      showFewOptionsCount={showFewOptionsCount}
      renderInputItem={(ind): ReactElement => {
        const { ref, value, ...rest } = options[ind];
        return (
          <Checkbox
            {...rest}
            ref={ref as React.Ref<HTMLInputElement>}
            key={value}
            value={value}
            checked={selectedValues.includes(value ?? "")}
            onChange={onChangeHandle}
          />
        );
      }}
    />
  ) : (
    <></>
  );
};

export default CheckboxFilterInput;
